import { render, staticRenderFns } from "./MultiChoiceTextInput.vue?vue&type=template&id=9cf9d468&scoped=true&"
import script from "./MultiChoiceTextInput.vue?vue&type=script&lang=js&"
export * from "./MultiChoiceTextInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoiceTextInput.vue?vue&type=style&index=0&id=9cf9d468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf9d468",
  null
  
)

export default component.exports